/**
 * Um bloco titulado do painel.
 *
 * MORAVA EM `PainelDetalhe.tsx`, e saiu de la quando `AnaliseHumana.tsx`
 * passou a precisar dele: o painel importa a analise humana, e a analise
 * humana importava a secao do painel — ciclo de import, do tipo que o bundler
 * as vezes resolve e as vezes nao, e que quando nao resolve da
 * `undefined is not a component` em tempo de execucao, nao em compilacao.
 *
 * Continua um so lugar de propósito: um segundo `<section><h3>` divergiria do
 * primeiro na primeira mudanca de estilo.
 *
 * NO DETALHE DA OPORTUNIDADE ELA É UMA RUBRICA (28/10, "organize todas essas
 * telas dessas abas como você fez em visão geral"): o nome na margem
 * esquerda, com a conta embaixo em número grande e fino, e o conteúdo ao
 * lado — a forma do parecer técnico em papel. O desenho mora em
 * `PainelDetalhe.module.css`, sob `.corpo`: fora do detalhe (a ficha do
 * atestado) a seção continua com o título em cima.
 */
import css from "./PainelDetalhe.module.css";

export function Secao({
  titulo,
  conta,
  sub,
  tom,
  id,
  children,
}: {
  titulo: string;
  conta?: number;
  /** Uma linha de apoio embaixo do nome ("3 altos", "a protocolar"). */
  sub?: string;
  /** O filete de cima na cor de um estado (o veredito). */
  tom?: "ok" | "atencao" | "perigo" | "nao";
  /** Para levar até ela de outro lugar da tela. */
  id?: string;
  children: React.ReactNode;
}) {
  if (!children) return null;
  return (
    <section className={`${css.secao} ${tom ? css[`secao_${tom}`] : ""}`} id={id}>
      <h3>
        <span className={css.secaoNome}>{titulo}</span>
        {conta !== undefined ? <i>{conta}</i> : null}
        {sub ? <small>{sub}</small> : null}
      </h3>
      <div className={css.secaoTexto}>{children}</div>
    </section>
  );
}
